<template>
  <!-- "Sprache" row of a detail panel: the Google translation languages of the job server page in the frame -->
  <b-dropdown
    class="ts-panel-language"
    variant="link"
    toggle-class="ts-panel-info-row ts-panel-info-action"
    menu-class="ts-panel-language-menu"
    block
    no-caret
  >
    <template #button-content>
      <i class="bi bi-globe ts-panel-info-icon" aria-hidden="true"></i>
      <span class="ts-panel-info-text">{{ label }}</span>
      <i class="bi bi-chevron-right ts-panel-language-chevron" aria-hidden="true"></i>
    </template>
    <b-dropdown-item
      v-for="language in languages"
      :key="language.value"
      :active="language.value === value"
      @click="$emit('select', language.value)"
    >
      {{ language.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FrameLanguage } from '@/sections/frameBar';

@Component
export default class TsPanelLanguage extends Vue {
  @Prop({ type: Array, required: true }) readonly languages!: FrameLanguage[];

  // The page's own "choose a language" text, shown until a language is picked
  @Prop({ default: '' }) readonly prompt!: string;

  @Prop({ default: '' }) readonly value!: string;

  get label(): string {
    const language = this.languages.find((item) => item.value === this.value);
    return language ? language.label : this.prompt;
  }
}
</script>
